<script lang="ts">
    import { onMount } from 'svelte';
    import Newsletter from '../components/Newsletter.svelte';
    import ActuInsight from '../components/ActuInsight.svelte';
    import BallsActus from '../components/BallsActus.svelte';
    import { storeActus, Actu } from '../scripts/classes/actu';
    import { ACTU_CATEGORY_ACTUALITE, ACTU_CATEGORY_APPEL_A_PROJET, ACTU_CATEGORY_EVENEMENT, ACTU_CATEGORY_PTCE, EVENT_DISTANCIAL, EVENT_PRESENTIAL } from "../scripts/constant"
    import NewsletterRegistration from '../components/NewsletterRegistration.svelte';

    let actusFiltered: Actu[] = $storeActus;
    let actusFilteredAndSearched: Actu[] = $storeActus;
    let categoryFilter: number = 0;
    let keywords: string = "";
    let numberOfActusDisplayed: number = 10;
    let numberOfActusTotal: number = $storeActus.length;
    let isCloseSearchDisplayed: boolean = false;

    onMount(async () => {
        window.scrollTo(0,0);
        
	});

    function filterActus(inFilter: number) {
        if (inFilter == categoryFilter) {
            categoryFilter = 0;
            actusFiltered = $storeActus;
        } else {
            categoryFilter = inFilter;
            actusFiltered = $storeActus.filter(actu => {
                return (actu.actu_category == inFilter)
            });
        }
        searchText('OR');
    }

    function searchText(method: string) {
        if (keywords == "") {
            actusFilteredAndSearched = actusFiltered;
            isCloseSearchDisplayed = false;
        } else {
            if (isCloseSearchDisplayed) {
                keywords = "";
                actusFilteredAndSearched = actusFiltered;
                isCloseSearchDisplayed = false;
            } else {
                isCloseSearchDisplayed = true;
                const key = keywords.toLowerCase().trim().split(" ")[0];
                let itemTempo = actusFiltered;
                let itemTempo2 = [];
                itemTempo = actusFiltered.filter(item => {
                    if (method == "OR") {
                        return (item.subtitle.toLowerCase().indexOf(key) >= 0 || item.text.toString() == key);
                    } else if (method == "AND") {
                        return (item.subtitle.toLowerCase().indexOf(key) >= 0 && item.text.toString() == key);
                    } else {
                        return false;
                    }
                });
                actusFilteredAndSearched = itemTempo2.concat(itemTempo);
                itemTempo2 = actusFilteredAndSearched;
            }
        }
        actusFilteredAndSearched = Array.from(new Set(actusFilteredAndSearched));
        numberOfActusTotal = actusFilteredAndSearched.length;
        changeBG();
    }

    function changeBG() {
        const searchChamp = document.getElementById("searchChamp");
        if (keywords == "") {
            searchChamp.style.background = '#f1f1ef';
        } else {
            searchChamp.style.background = '#FFFFFF';
        }
    }

    function moreActus() {
        numberOfActusDisplayed = numberOfActusDisplayed + 10;
    }

</script>
    
<style lang="scss">

    .actus {
        &__filters {
            font-family: 'Borna-Medium';
            font-size: 13px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: 60px 0 0 0;
            width: 110%;
            height: 27.5px;
            &__button {
                width: auto;
                height: 100%;
                background-color: $color_white;
                border: 1px solid $color_black;
                border-left: 0px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 0 10px 0 10px;
                box-sizing: border-box;
                &__selected {
                    background-color: $color_primary;
                }
                &__first {
                    border-left: 1px solid $color_black;
                    border-radius: 30px 0 0 30px;
                }
                &__last {
                    border-radius: 0px 30px 30px 0;
                }
            }
        }
        &__search {
            width: 90%;
            border: 1px solid $color_black;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 5px;
            box-sizing: border-box;
            &__input__mobile {
                all: unset;
                width: 100%;
                border: none;
                font-family: 'Borna-Medium';
                font-size: 14px;
                padding: 20px 20px 20px 20px;
            }
            &__input {
                display: none;
            }
            &__btn {
                cursor: pointer;
                margin: 0 15px 0 0;
                width: 50px;
                height: 50px;
                background-image: url('../assets/images/btn_search.svg');
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                &__close {
                    background-image: url('../assets/images/btn_close.svg');
                }
            }
        }
        &__lesactus {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            margin: 0 0 50px 0px;
        }
        &__actuinsight {
            margin: 36px 15px 0 15px;
        }
        &__more {
            margin-bottom: -25px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-family: 'Borna-Medium';
            font-size: 14px;
            &__btn {
                cursor: pointer;
                margin: 15px 0 0 0;
                width: 50px;
                height: 50px;
                background-image: url('../assets/images/btn_charger_plus.svg');
            }
        }
    }

    @include large {
        .actus {
            &__filters {
                width: auto;
                font-size: 1.2vw;
                height: 60px;
                position: absolute;
                margin: -30px 0 0 0;
                align-self: flex-end;
                justify-content: center;
                &__button {
                    width: auto;
                    cursor: pointer;
                    margin: 0 20px 0 0;
                    padding: 0 30px 0 30px;
                    border-radius: 30px;
                    border-left: 1px solid $color_black;
                    &:hover {
                        background-color: $color_primary;
                    }
                    &__first {
                        border-left: 1px solid $color_black;
                    }
                }
            }
            &__search {
                width: 100%;
                &__input__mobile {
                    display: none;
                }
                &__input {
                    all: unset;
                    width: 100%;
                    border: none;
                    font-family: 'Borna-Medium';
                    font-size: 1.1vw;
                    padding: 20px 20px 20px 20px;
                }
                &__btn {
                    &:hover {
                        background-image: url('../assets/images/btn_search_hover.svg');
                    }
                    &__close {
                        &:hover {
                            background-image: url('../assets/images/btn_close_hover.svg');
                        }
                    }
                }
            }
            &__lesactus {
                flex-direction: row;
                margin: 0 0 70px 0px;
            }
            &__actuinsight {
                margin: 50px 15px 0 15px;
            }
            &__more {
                &__btn {
                    &:hover {
                        background-image: url('../assets/images/btn_charger_plus_hover.svg');
                    }
                }
            }
        }

    }

    @include xlarge {
        .actus {
            &__filters {
                font-size: 22px;
            }
            &__search {
                &__input {
                    font-size: 20px;
                }
            }
        }
    }

</style>

<div class="page">
    <div class="page__contener">
        <div class="page__title">les actualités</div>
        <div class="actus__filters">
            <div class="actus__filters__button actus__filters__button__first" class:actus__filters__button__selected={categoryFilter == ACTU_CATEGORY_PTCE} on:click={() => filterActus(ACTU_CATEGORY_PTCE)} on:keydown={() => filterActus(ACTU_CATEGORY_PTCE)}>PTCE</div>
            <div class="actus__filters__button" class:actus__filters__button__selected={categoryFilter == ACTU_CATEGORY_ACTUALITE} on:click={() => filterActus(ACTU_CATEGORY_ACTUALITE)} on:keydown={() => filterActus(ACTU_CATEGORY_ACTUALITE)}>actualités</div>
            <div class="actus__filters__button" class:actus__filters__button__selected={categoryFilter == ACTU_CATEGORY_EVENEMENT} on:click={() => filterActus(ACTU_CATEGORY_EVENEMENT)} on:keydown={() => filterActus(ACTU_CATEGORY_EVENEMENT)}>évènements</div>
            <div class="actus__filters__button actus__filters__button__last" class:actus__filters__button__selected={categoryFilter == ACTU_CATEGORY_APPEL_A_PROJET} on:click={() => filterActus(ACTU_CATEGORY_APPEL_A_PROJET)} on:keydown={() => filterActus(ACTU_CATEGORY_APPEL_A_PROJET)}>appel&nbsp;à&nbsp;projet</div>
        </div>
        <div class="page__content">
            <div id="searchChamp" class="actus__search">
                <input class="actus__search__input" id="searchInput" name="searchInput" type="text" placeholder="Rechercher par des mots clés: présentiel, distanciel, Pays-de-la-Loire ..." bind:value={keywords} on:input={() => changeBG()}>
                <input class="actus__search__input__mobile" id="searchInput" name="searchInput" type="text" placeholder="Rechercher par mots clés ..." bind:value={keywords} on:input={() => changeBG()}>
                <div class="actus__search__btn" class:actus__search__btn__close={isCloseSearchDisplayed} on:click={() => searchText("OR")} on:keydown={() => searchText("OR")}></div>
            </div>
            <div class="actus__lesactus">
                {#key numberOfActusDisplayed}
                {#each actusFilteredAndSearched as actu, i}
                {#if (i < numberOfActusDisplayed)}
                <div class="actus__actuinsight">
                    {#key actu}
                    <ActuInsight inActu={actu}/>
                    {/key}
                </div>
                {/if}
                {/each}
                {/key}
            </div>
            {#if numberOfActusDisplayed < numberOfActusTotal}
            <div class="actus__more">
                <div>charger</div>
                <div>plus d'actualités</div>
                <div class="actus__more__btn" on:click={moreActus} on:keydown={moreActus}></div>
            </div>
            {/if}
        </div>
    </div>
    <BallsActus />
    <Newsletter />
    <NewsletterRegistration />
</div>
